module.exports = __webpack_public_path__ + "images/temporaryStop.da68eb7044d6f2257cce8e6ce2f3bc04.png";